import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import TextField from 'material-ui/TextField/TextField';
import utils from 'helpers/utils';

const TextToArrayFilter = (props) => {
    const {
        input,
        label,
        meta: {
            touched,
            error,
        },
        options,
    } = props;

    const handleFocus = (event) => {
        input.onFocus(event);
    };

    const handleChange = (event) => {
        let inputValue = event.target.value;
        let value = inputValue;

        /**
         * When the value exists, we will transform the value to an Array.
         * If the value is empty, we will send just that value, so it will be picked up by the ReduxForm.
         */
        if (value) {
            value = [
                inputValue,
            ];
        }

        input.onChange(value);
    };

    let value = input.value;

    if (utils.isArray(value)) {
        value = value[0];
    }

    return (
        <TextField
            errorText={ touched && error }
            onChange={ handleChange }
            onFocus={ handleFocus }
            type='text'
            floatingLabelText={ label ? <FieldTitle
                label={ label }
                source={ 'source' }
                resource={ 'resource' }
            /> : '' }
            value={ value }
            name={ input.name }
            { ...options }
        />
    );
};

TextToArrayFilter.propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    name: PropTypes.string,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    validate: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.func),
    ]),
};

export default TextToArrayFilter;



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/TextToArrayFilter.js